"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "getEvent", {
  enumerable: true,
  get: function get() {
    return _getEvent["default"];
  }
});
var _getEvent = _interopRequireDefault(require("./getEvent"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }